/*
 * Copyright 2026 North Carolina State University
 */

import React, { useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import NewApplication from '../shared/NewApplication';

const EditApplication = ({ user }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [hasChanges, setHasChanges] = useState(false);

  // Use the application data passed through navigation state
  const applicationData = location.state?.application;

  const handleCancel = () => {
    if (hasChanges) {
      if (window.confirm('Are you sure you want to discard your changes?')) {
        navigate('/applications/saved');
      }
    } else {
      navigate('/applications/saved');
    }
  };

  const handleSaveChanges = async () => {
    if (window.confirm('Are you sure you want to save these changes?')) {
      return true;
    }
    return false;
  };

  if (!applicationData) {
    return <div>No application data found</div>;
  }

  return (
    <div className="edit-application">
      <div className="edit-header">
        <h1>Edit Application</h1>
        <div className="edit-actions">
          <button className="cancel-btn" onClick={handleCancel}>Cancel</button>
        </div>
      </div>
      <NewApplication 
        mode="edit"
        user={user}
        applicationId={id}
        onFormChange={() => setHasChanges(true)}
        onSaveConfirm={handleSaveChanges}
        initialData={applicationData}
      />
    </div>
  );
};

export default EditApplication;